<form class="project-integration-form" [formGroup]="form" (ngSubmit)="onSubmit()">
  @if (selectedProviders().includes('JIRA')) {
    <div
      class="project-integration-form__account-info"
      [class.project-integration-form__account-info--warning]="hasJiraToken() === false"
    >
      <mat-icon>{{ hasJiraToken() === false ? 'warning' : 'info' }}</mat-icon>
      <span>
        {{
          (hasJiraToken() === false ? 'settings.integration.noTokenWarning' : 'settings.integration.accountInfo')
            | translate
        }}
      </span>
      <a [routerLink]="['/account']">{{ 'settings.integration.toAccountSettings' | translate }}</a>
    </div>
  }

  <mat-form-field appearance="fill" class="project-integration-form__field">
    <mat-label>{{ 'settings.integration.providerLabel' | translate }}</mat-label>
    <mat-select formControlName="selectedProviders" multiple (selectionChange)="onProviderSelectionChange()">
      <mat-option value="JIRA">Jira</mat-option>
      <mat-option value="REDMINE">Redmine</mat-option>
    </mat-select>
  </mat-form-field>

  @if (selectedProviders().includes('JIRA')) {
    <h3 class="project-integration-form__provider-header">{{ 'settings.integration.jiraHeader' | translate }}</h3>

    <app-provider-board-section
      [boardUrls]="jiraBoardUrls"
      [integrationIds]="jiraIntegrationIds"
      [testResults]="jiraTestResults"
      [isTesting]="jiraIsTesting"
      [maxBoards]="MAX_BOARDS"
      (addBoard)="addBoardUrl('JIRA')"
      (removeBoard)="removeBoardUrl('JIRA', $event)"
      (testBoard)="testConnection('JIRA', $event)"
    ></app-provider-board-section>

    @if (selectedProviders().includes('REDMINE')) {
      <mat-divider class="project-integration-form__provider-divider"></mat-divider>
    }
  }

  @if (selectedProviders().includes('REDMINE')) {
    <h3 class="project-integration-form__provider-header">{{ 'settings.integration.redmineHeader' | translate }}</h3>

    <app-provider-board-section
      [boardUrls]="redmineBoardUrls"
      [integrationIds]="redmineIntegrationIds"
      [testResults]="redmineTestResults"
      [isTesting]="redmineIsTesting"
      [maxBoards]="MAX_BOARDS"
      (addBoard)="addBoardUrl('REDMINE')"
      (removeBoard)="removeBoardUrl('REDMINE', $event)"
      (testBoard)="testConnection('REDMINE', $event)"
    ></app-provider-board-section>
  }

  @if (saveError()) {
    <p class="project-integration-form__result project-integration-form__result--error">
      <mat-icon>error</mat-icon>
      {{ 'settings.integration.saveError' | translate }}
    </p>
  }

  @if (selectedProviders().length > 0) {
    <div class="project-integration-form__actions">
      <button
        mat-flat-button
        color="primary"
        type="submit"
        [disabled]="isSaving() || !isDirty() || (selectedProviders().includes('JIRA') && hasJiraToken() === false)"
      >
        @if (isSaving()) {
          <mat-progress-spinner diameter="20" mode="indeterminate"></mat-progress-spinner>
        } @else {
          {{ 'settings.integration.save' | translate }}
        }
      </button>
    </div>
  } @else {
    <p class="project-integration-form__no-provider-hint">
      {{ 'settings.integration.noProviderHint' | translate }}
    </p>
  }
</form>
